module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTk3Ni4yIDc4NS4zIDUwMS42IDIyMy44IDI3IDc4NS4zIDYyLjIgODE1IDUwMS42IDI5NS4xIDk0MSA4MTVaIiBwLWlkPSIxMDcyIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/totop.svg
// module id = F9jj
// module chunks = 75